import type { FC } from 'react';

import { useUISettings } from 'store';

import type { GeneralMenuItemProps } from './types';

const SandwichMenuItem: FC<GeneralMenuItemProps> = ({
  children,
  className,
}) => {
  const [{ showSandwichMenu }, { toggleSandwichMenu }] = useUISettings();

  return (
    <button
      type="button"
      className={className(showSandwichMenu)}
      onClick={toggleSandwichMenu}
    >
      {children}
    </button>
  );
};

export default SandwichMenuItem;
